import { flow, map, keyBy, debounce } from 'lodash/fp';
import axios from 'axios';

import actionTypes from './index';
import config from '../../helpers/config';

const categoryMapping = {
  0: 'unknown',
  1: 'blinds-shades',
  2: 'roller-shades',
  3: 'verticals',
  4: 'perfect-arch',
};

const getWindowCategories = dispatch => axios.get(`${config.newMandiBaseUrl}/api/jobs/window-categories`)
  .then(res => dispatch({
    type: actionTypes.WINDOW_CATEGORY_MAPPINGS,
    payload: flow(
      map(it => ({
        ...it,
        key: categoryMapping[it.categoryId],
      })),
      keyBy('key'),
    )(res.data),
  }));
const limitGetWindowCategories = debounce([10000, { leading: true }], getWindowCategories);
export default () => limitGetWindowCategories;
